/**
 * shoppable-video.js
 * Shoppable Video — Thumbnail Carousel + Floating Popup Player
 *
 * Both carousels now run on the theme's native FoxTheme.Carousel
 * (a thin wrapper around the theme's bundled Swiper instance):
 *  - Thumbnail row: horizontal, slidesPerView 2.3/4.
 *  - Popup player: vertical "stories" slider — Swiper owns all touch/drag
 *    handling natively (Instagram Reels-style vertical swipe), instead of
 *    a hand-rolled touch implementation.
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     STATE
  ───────────────────────────────────────────── */
  var thumbSwiper      = null;
  var popupCarousel    = null;   // FoxTheme.Carousel instance for the popup
  var currentIndex     = 0;
  var isMuted          = true;
  var progressCleanup  = null;   // replaces progressInterval — stores cleanup fn
  var totalSlides      = 0;
  var bodyOverflowPrev = '';     // stores body's original overflow so we can restore it

  /* Cached DOM */
  var popup, trackWrap, track, slides, popupVids, muteButtons, progressFills;

  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
function init() {
  var section = document.getElementById('sivSection');
  popup = document.getElementById('sivPopup');
  if (!section || !popup) return;



    /* Move popup to <body> — prevents overflow:hidden clipping */
    document.body.appendChild(popup);

    /* Cache internals */
    trackWrap      = document.getElementById('sivTrackWrap');
    track          = document.getElementById('sivTrack');
    slides         = Array.from(track.querySelectorAll('.siv-popup-slide'));
    popupVids      = slides.map(function (s) { return s.querySelector('.siv-popup-vid'); });
    muteButtons    = slides.map(function (s) { return s.querySelector('.siv-mute-btn'); });
    progressFills  = slides.map(function (s) { return s.querySelector('.siv-progress-fill'); });
    totalSlides    = slides.length;

    initThumbs();
    initPopupSlider();

    /* Add to cart — delegates click to the real ATC button */
    var sivAddBtn = document.querySelector('.siv-add-btn');
    if (sivAddBtn) {
      sivAddBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var atcBtn = document.querySelector('.product__info-container .product-form__submit');
        if (atcBtn) atcBtn.click();
        setTimeout(() => {
          
          closePopup();
        }, 500);
      });
    }

    /* Popup controls */
    document.getElementById('sivClose').addEventListener('click', closePopup);
    document.getElementById('sivNavUp').addEventListener('click', function () { navigate(-1); });
    document.getElementById('sivNavDown').addEventListener('click', function () { navigate(1); });

    /* Per-slide: mute + play/pause */
    slides.forEach(function (slide, i) {
      if (muteButtons[i]) {
        muteButtons[i].addEventListener('click', function (e) {
          e.stopPropagation();
          toggleMute();
        });
      }
      popupVids[i].addEventListener('click', function () {
        togglePlayPause(i);
      });
    });

    /* Keyboard */
    document.addEventListener('keydown', function (e) {
      if (!popup.classList.contains('is-visible')) return;
      if (e.key === 'Escape')    closePopup();
      if (e.key === 'ArrowUp')   navigate(-1);
      if (e.key === 'ArrowDown') navigate(1);
    });

    /* Resize — let Swiper recalculate slide sizing */
    window.addEventListener('resize', debounce(function () {
      if (popupCarousel && popupCarousel.slider) popupCarousel.slider.update();
    }, 200));
  }

  /* ─────────────────────────────────────────────
     THUMBNAIL CAROUSEL — theme-native (FoxTheme.Carousel)
  ───────────────────────────────────────────── */
function initThumbs() {
  var section  = document.getElementById('sivSection');
  var thumbsEl = document.getElementById('sivThumbs');

  if (thumbsEl && window.FoxTheme && typeof window.FoxTheme.Carousel === 'function') {
    thumbSwiper = new window.FoxTheme.Carousel(thumbsEl, {
      slidesPerView: 2.3,
      spaceBetween: 18,
      watchSlidesProgress: true,
      navigation: {
        nextEl: document.querySelector('.siv-next-btn'),
        prevEl: document.querySelector('.siv-prev-btn'),
      },
      breakpoints: {
        768: { slidesPerView: 3 }
      },
      on: {
        init: function () {
          requestAnimationFrame(function () {
            if (section) section.style.opacity = '1';
          });
        }
      }
    });
    thumbSwiper.init();
  } else if (typeof Swiper !== 'undefined' && thumbsEl) {
    /* Fallback if FoxTheme.Carousel isn't available for any reason */
    thumbSwiper = new Swiper(thumbsEl, {
      slidesPerView: 2.3,
      spaceBetween: 18,
      watchSlidesProgress: true,
      navigation: {
        prevEl: '.siv-prev-btn',
        nextEl: '.siv-next-btn',
      },
      breakpoints: {
        768: { slidesPerView: 4 }
      },
      on: {
        init: function () {
          requestAnimationFrame(function () {
            if (section) section.style.opacity = '1';
          });
        }
      }
    });
  } else {
    requestAnimationFrame(function () {
      if (section) section.style.opacity = '1';
    });
  }

  /* Autoplay thumb videos when visible */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var vid = entry.target;
        entry.isIntersecting ? vid.play().catch(function () {}) : vid.pause();
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('.siv-thumb-vid').forEach(function (v) {
      io.observe(v);
    });
  }

  /* Click / keyboard → open popup */
  document.querySelectorAll('.siv-thumb').forEach(function (thumb) {
    var idx = parseInt(thumb.getAttribute('data-index'), 10);
    if (isNaN(idx)) idx = 0;

    thumb.addEventListener('click', function () { openPopup(idx); });
    thumb.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openPopup(idx);
      }
    });
  });
}

  /* ─────────────────────────────────────────────
     POPUP SLIDER — theme-native (FoxTheme.Carousel),
     direction: vertical. Swiper handles all touch/drag natively,
     including rubber-band resistance at the ends and momentum —
     this replaces the previous hand-rolled translateY dragging.
  ───────────────────────────────────────────── */
  function initPopupSlider() {
    if (!trackWrap || !(window.FoxTheme && typeof window.FoxTheme.Carousel === 'function')) {
      return;
    }

    popupCarousel = new window.FoxTheme.Carousel(trackWrap, {
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 320,
      threshold: 4,
      resistanceRatio: 0.35,
      watchSlidesProgress: true,
      on: {
        slideChangeTransitionStart: function () {
          pauseCurrentVideo();
          resetProgress(currentIndex);
          stopProgress();
        },
        slideChangeTransitionEnd: function () {
          currentIndex = popupCarousel.slider.activeIndex;
          playCurrentVideo();
          startProgress();
          updateNavButtons();
          updateActiveThumbnail();
        }
      }
    });
    popupCarousel.init();
  }

  /* ─────────────────────────────────────────────
     POPUP — OPEN / CLOSE
     `hidden` is the source of truth for removing the popup (and every
     focusable descendant inside it) from the tab order + accessibility
     tree. aria-hidden is kept in sync alongside it for AT that also
     reads that attribute directly.
  ───────────────────────────────────────────── */
  function openPopup(idx) {
    currentIndex = clamp(idx, 0, totalSlides - 1);

    if (popupCarousel && popupCarousel.slider) {
      popupCarousel.slider.slideTo(currentIndex, 0);
    }

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    /* Next frame so the browser registers the un-hide before animating in */
    requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });

    /* Lock background page scroll while the popup is open */
    bodyOverflowPrev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(function () {
      playCurrentVideo();
      startProgress();
      updateNavButtons();
      updateActiveThumbnail();
      if (document.getElementById('sivClose')) document.getElementById('sivClose').focus();
    });
  }

  function closePopup() {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    pauseAllVideos();
    stopProgress();
    clearActiveThumbnail();

    document.body.style.overflow = bodyOverflowPrev;

    /* Wait for the fade/transform transition to finish before removing
       it from the tab order, so the closing animation still plays. */
    setTimeout(function () {
      popup.hidden = true;
    }, 300);
  }

  /* ─────────────────────────────────────────────
     NAVIGATION — delegates to the Swiper instance;
     slideChangeTransitionStart/End above handle the
     pause/play/progress/UI bookkeeping for every trigger
     (buttons, keyboard, or a real swipe).
  ───────────────────────────────────────────── */
  function navigate(dir) {
    if (!popupCarousel || !popupCarousel.slider) return;
    if (dir > 0) {
      popupCarousel.slider.slideNext();
    } else {
      popupCarousel.slider.slidePrev();
    }
  }

  /* ─────────────────────────────────────────────
     VIDEO PLAYBACK
  ───────────────────────────────────────────── */
  function playCurrentVideo() {
    var vid = popupVids[currentIndex];
    if (!vid) return;
    vid.muted = isMuted;
    var p = vid.play();
    if (p && p.catch) p.catch(function () {});
    slides[currentIndex].classList.remove('is-paused');
    syncMuteIcon(currentIndex);
  }

  function pauseCurrentVideo() {
    var vid = popupVids[currentIndex];
    if (vid) vid.pause();
  }

  function pauseAllVideos() {
    popupVids.forEach(function (v) {
      if (v) { v.pause(); v.currentTime = 0; }
    });
    slides.forEach(function (s) { s.classList.remove('is-paused'); });
  }

  function togglePlayPause(idx) {
    var vid = popupVids[idx];
    if (!vid) return;
    if (vid.paused) {
      var p = vid.play();
      if (p && p.catch) p.catch(function () {});
      slides[idx].classList.remove('is-paused');
      startProgress();
    } else {
      vid.pause();
      slides[idx].classList.add('is-paused');
      stopProgress();
    }
  }

  /* ─────────────────────────────────────────────
     MUTE
  ───────────────────────────────────────────── */
  function toggleMute() {
    isMuted = !isMuted;
    var vid = popupVids[currentIndex];
    if (vid) vid.muted = isMuted;
    syncMuteIcon(currentIndex);
  }

  function syncMuteIcon(idx) {
    var btn = muteButtons[idx];
    if (!btn) return;
    var mutedIco = btn.querySelector('.siv-ico-muted');
    var soundIco = btn.querySelector('.siv-ico-sound');
    if (mutedIco) mutedIco.style.display = isMuted ? '' : 'none';
    if (soundIco) soundIco.style.display = isMuted ? 'none' : '';
  }

  /* ─────────────────────────────────────────────
     PROGRESS BAR
     Uses native video events — no polling interval.
  ───────────────────────────────────────────── */
  function startProgress() {
    stopProgress();
    var vid  = popupVids[currentIndex];
    var fill = progressFills[currentIndex];
    if (!vid || !fill) return;

    function onTimeUpdate() {
      if (vid.duration && !isNaN(vid.duration)) {
        fill.style.width = ((vid.currentTime / vid.duration) * 100).toFixed(2) + '%';
      }
    }

    function onEnded() {
      fill.style.width = '100%';
      if (currentIndex < totalSlides - 1) {
        navigate(1);
      } else {
        stopProgress();
      }
    }

    vid.addEventListener('timeupdate', onTimeUpdate);
    vid.addEventListener('ended', onEnded);

    /* Store cleanup so stopProgress always removes the right listeners */
    progressCleanup = function () {
      vid.removeEventListener('timeupdate', onTimeUpdate);
      vid.removeEventListener('ended', onEnded);
    };
  }

  function stopProgress() {
    if (typeof progressCleanup === 'function') progressCleanup();
    progressCleanup = null;
  }

  function resetProgress(idx) {
    if (progressFills[idx]) progressFills[idx].style.width = '0%';
  }

  /* ─────────────────────────────────────────────
     UI STATE
  ───────────────────────────────────────────── */
  function updateNavButtons() {
    var upBtn   = document.getElementById('sivNavUp');
    var downBtn = document.getElementById('sivNavDown');
    if (upBtn)   upBtn.disabled   = currentIndex === 0;
    if (downBtn) downBtn.disabled = currentIndex === totalSlides - 1;
  }

  function updateActiveThumbnail() {
    document.querySelectorAll('.siv-thumb').forEach(function (t, i) {
      t.classList.toggle('is-active', i === currentIndex);
    });
  }

  function clearActiveThumbnail() {
    document.querySelectorAll('.siv-thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
  }

  /* ─────────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────────── */
  function clamp(val, min, max) {
    return Math.max(min, Math.min(max, val));
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  /* ─────────────────────────────────────────────
     BOOT
  ───────────────────────────────────────────── */
if ('requestIdleCallback' in window) {
  requestIdleCallback(init, { timeout: 2000 });
} else {
  setTimeout(init, 200);
}

})();
